import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, DatePicker, Icon, notification, InputNumber } from "antd";
import axios from "axios";
import moment from "moment";

import SectionCard from "../../components/SectionCard";

const { TextArea } = Input;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message,
        description
    });
};

const criarDadosAluno = () => ({
    nome: "",
    data_nascimento: null,
    idade: null,
    escola: "",
    ano_turma: "",
    turno: "",
    professor_regente: "",
    professor_aee: "",
    data_registro: moment(new Date())
});

const criarDadosEstudoCaso = () => ({
    motivo_estudo_caso: "",
    historico_escolar: "",
    historico_desenvolvimento: "",
    informacoes_familia: "",
    observacao_contexto_escolar: "",
    aspectos_aprendizagem: "",
    potencialidades_interesses: "",
    barreiras_identificadas: "",
    recursos_acessibilidade: "",
    necessidades_educacionais: "",
    definicao_atendimento_objetivo_geral: "",
    definicao_atendimento_objetivos_especificos: "",
    plano_intervencao: "",
    articulacao_sala_regular: "",
    articulacao_familia_equipe: "",
    acompanhamento_reavaliacao: "",
    consideracoes_finais: ""
});

const converterData = valor => {
    if (!valor) return null;

    const data = moment(new Date(valor));

    return data.isValid() ? data : null;
};

const DrawerEstudoPAEE = ({ id, visible, atualizarListagem, onClose, form }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [dadosAluno, setDadosAluno] = useState(criarDadosAluno);
    const [dadosEstudoCaso, setDadosEstudoCaso] = useState(criarDadosEstudoCaso);

    const { getFieldDecorator } = form;

    const carregarDetalhe = idEstudo => {
        setIsLoading(true);

        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-estudo-caso-paee",
            params: {
                id: idEstudo
            }
        })
            .then(response => {
                const aluno = JSON.parse(response.data.dados_aluno || "{}");

                const estudo = JSON.parse(response.data.dados_estudo_caso || "{}");

                const alunoConvertido = {
                    ...criarDadosAluno(),
                    ...aluno,
                    data_nascimento: converterData(aluno.data_nascimento),
                    data_registro: converterData(aluno.data_registro)
                };

                const estudoCarregado = {
                    ...criarDadosEstudoCaso(),
                    ...estudo
                };

                setDadosAluno(alunoConvertido);
                setDadosEstudoCaso(estudoCarregado);

                form.setFieldsValue({
                    ...estudoCarregado,
                    ...alunoConvertido
                });
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Erro ao carregar o estudo de caso.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const limparCampos = () => {
        form.resetFields();
        setDadosAluno(criarDadosAluno());
        setDadosEstudoCaso(criarDadosEstudoCaso());
    };

    const handleClose = () => {
        onClose();
        limparCampos();
    };

    const adicionarEstudo = payload => {
        setIsLoading(true);

        axios({
            method: "post",
            url: "/api/estudo-caso/adicionar-plano-estudo-caso-paee",
            data: {
                id_disciplina: localStorage.getItem("codigo_curso"),
                tipo: "estudo_caso_paee",
                ...payload
            }
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Estudo de caso criado com sucesso.");

                atualizarListagem();
                handleClose();
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Erro ao criar o estudo de caso.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const alterarEstudo = payload => {
        setIsLoading(true);

        axios({
            method: "put",
            url: "/api/estudo-caso/alterar-plano-estudo-caso-paee",
            data: {
                id,
                ...payload
            }
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Estudo de caso alterado com sucesso.");

                atualizarListagem();
                handleClose();
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Erro ao alterar o estudo de caso.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleSubmit = e => {
        e.preventDefault();

        if (isLoading) return;

        form.validateFields((err, values) => {
            if (err) return;

            const payload = {
                dados_aluno: JSON.stringify({
                    nome: values.nome,
                    data_nascimento: values.data_nascimento.format("YYYY-MM-DD"),
                    idade: values.idade,
                    escola: values.escola,
                    ano_turma: values.ano_turma,
                    turno: values.turno,
                    professor_regente: values.professor_regente,
                    professor_aee: values.professor_aee,
                    data_registro: values.data_registro.format("YYYY-MM-DD")
                }),
                dados_estudo_caso: JSON.stringify({
                    motivo_estudo_caso: values.motivo_estudo_caso,
                    historico_escolar: values.historico_escolar,
                    historico_desenvolvimento: values.historico_desenvolvimento,
                    informacoes_familia: values.informacoes_familia,
                    observacao_contexto_escolar: values.observacao_contexto_escolar,
                    aspectos_aprendizagem: values.aspectos_aprendizagem,
                    potencialidades_interesses: values.potencialidades_interesses,
                    barreiras_identificadas: values.barreiras_identificadas,
                    recursos_acessibilidade: values.recursos_acessibilidade,
                    necessidades_educacionais: values.necessidades_educacionais,
                    definicao_atendimento_objetivo_geral: values.definicao_atendimento_objetivo_geral,
                    definicao_atendimento_objetivos_especificos: values.definicao_atendimento_objetivos_especificos,
                    plano_intervencao: values.plano_intervencao,
                    articulacao_sala_regular: values.articulacao_sala_regular,
                    articulacao_familia_equipe: values.articulacao_familia_equipe,
                    acompanhamento_reavaliacao: values.acompanhamento_reavaliacao,
                    consideracoes_finais: values.consideracoes_finais
                })
            };

            if (id) {
                alterarEstudo(payload);
            } else {
                adicionarEstudo(payload);
            }
        });
    };

    const carregarDadosAlunoEnsinoEspecial = () => {
        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-informacoes-ensino-especial",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const { aluno, turma } = response.data;

                const alunoConvertido = {
                    ...criarDadosAluno(),
                    nome: aluno?.nome || "",
                    data_nascimento: aluno?.dataNascimento ? moment(new Date(aluno.dataNascimento)) : null,
                    idade: aluno?.idade ?? null,
                    ano_turma: turma?.nome || "",
                    professor_regente: turma?.professor || "",
                    escola: turma?.escola || "",
                    turno: turma?.turno || ""
                };

                setDadosAluno(alunoConvertido);

                form.setFieldsValue({
                    ...alunoConvertido
                });
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao carregar dados.");
            });
    };

    const afterVisibleChange = aberto => {
        if (!aberto && id === null) {
            limparCampos();
        }
    };

    useEffect(() => {
        if (visible && id) {
            carregarDetalhe(id);
        }

        if (visible && !id) {
            carregarDadosAlunoEnsinoEspecial();
        }
    }, [visible, id]);

    const renderTextArea = (title, fieldName, label, placeholder, rows = 5, required = false) => (
        <SectionCard title={title}>
            <Form.Item label={label}>
                {getFieldDecorator(fieldName, {
                    initialValue: dadosEstudoCaso[fieldName],
                    rules: required ? [{ required: true, message: "Campo obrigatório" }] : []
                })(<TextArea rows={rows} placeholder={placeholder} style={{ minHeight: 130 }} />)}
            </Form.Item>
        </SectionCard>
    );

    return (
        <Drawer
            title="Estudo de Caso para Elaboração do PAEE"
            className="drawer-adicionar-evento drawer-add-cursos"
            width={900}
            onClose={handleClose}
            visible={visible}
            style={{
                overflow: "auto",
                height: "calc(100% - 108px)",
                paddingBottom: "108px"
            }}
            maskClosable={false}
            afterVisibleChange={afterVisibleChange}
        >
            <div className="bloco-info">
                <Form className="form-categorias" layout="horizontal" onSubmit={handleSubmit}>
                    <SectionCard title="1. Dados da criança">
                        <Form.Item label="Nome">
                            {getFieldDecorator("nome", {
                                initialValue: dadosAluno.nome,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Data Nascimento">
                            {getFieldDecorator("data_nascimento", {
                                initialValue: dadosAluno.data_nascimento,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ]
                            })(<DatePicker format="DD-MM-YYYY" placeholder="Selecionar" />)}
                        </Form.Item>

                        <Form.Item label="Idade">
                            {getFieldDecorator("idade", {
                                initialValue: dadosAluno.idade,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    },
                                    {
                                        type: "number",
                                        message: "Apenas números são permitidos"
                                    }
                                ]
                            })(<InputNumber min={0} precision={0} />)}
                        </Form.Item>

                        <Form.Item label="Escola">
                            {getFieldDecorator("escola", {
                                initialValue: dadosAluno.escola,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Turma/ano">
                            {getFieldDecorator("ano_turma", {
                                initialValue: dadosAluno.ano_turma,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Turno">
                            {getFieldDecorator("turno", {
                                initialValue: dadosAluno.turno,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Professor(a) Regente">
                            {getFieldDecorator("professor_regente", {
                                initialValue: dadosAluno.professor_regente,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Professor(a) AEE">
                            {getFieldDecorator("professor_aee", {
                                initialValue: dadosAluno.professor_aee,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Data">
                            {getFieldDecorator("data_registro", {
                                initialValue: dadosAluno.data_registro,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ]
                            })(<DatePicker format="DD-MM-YYYY" placeholder="Selecionar" />)}
                        </Form.Item>
                    </SectionCard>

                    {renderTextArea(
                        "2. Motivo do Estudo de Caso",
                        "motivo_estudo_caso",
                        "",
                        "Descreva a situação que motivou a realização do estudo de caso e a identificação da necessidade de acompanhamento educacional especializado..."
                    )}

                    {renderTextArea(
                        "3. Histórico Escolar",
                        "historico_escolar",
                        "",
                        "Trajetória escolar, frequência, participação nas atividades, desempenho acadêmico, dificuldades e avanços observados, estratégias pedagógicas já utilizadas, atendimentos anteriores ou atuais..."
                    )}

                    {renderTextArea(
                        "4. Histórico do Desenvolvimento",
                        "historico_desenvolvimento",
                        "",
                        "Registre aspectos relacionados ao desenvolvimento: motor, cognitivo, linguagem e comunicação, autonomia, interação social, comportamento, outras informações relevantes..."
                    )}

                    {renderTextArea(
                        "5. Informações da Família",
                        "informacoes_familia",
                        "",
                        "Composição familiar, rotina do estudante, percepção da família sobre a aprendizagem, potencialidades e interesses, apoios realizados pela família, acompanhamentos especializados..."
                    )}

                    {renderTextArea(
                        "6. Observação do Estudante no Contexto Escolar",
                        "observacao_contexto_escolar",
                        "",
                        "Descreva como o estudante se comunica, interage, participa das atividades, compreende orientações, demonstra autonomia, utiliza materiais, responde às estratégias pedagógicas, enfrenta mudanças de rotina e manifesta suas necessidades...",
                        8
                    )}

                    {renderTextArea(
                        "7. Aspectos da Aprendizagem",
                        "aspectos_aprendizagem",
                        "",
                        "Ex: Leitura - realiza leitura silábica com apoio...\nEscrita - apresenta dificuldade em...\nMatemática - consegue realizar...\nComunicação - ...",
                        10
                    )}

                    {renderTextArea(
                        "8. Potencialidades e Interesses do Estudante",
                        "potencialidades_interesses",
                        "",
                        "Registre aquilo que o estudante realiza com autonomia, suas habilidades, preferências, interesses, formas de comunicação e estratégias que facilitam sua aprendizagem..."
                    )}

                    {renderTextArea(
                        "9. Barreiras Identificadas",
                        "barreiras_identificadas",
                        "",
                        "Identifique as barreiras que interferem na participação e aprendizagem: pedagógicas, comunicacionais, atitudinais, físicas/arquitetônicas, relacionadas aos recursos e materiais, para participação e autonomia..."
                    )}

                    {renderTextArea(
                        "10. Recursos de Acessibilidade e Estratégias Necessárias",
                        "recursos_acessibilidade",
                        "",
                        "Registre os recursos que poderão favorecer a participação do estudante: materiais adaptados, recursos visuais, tecnologia assistiva, comunicação alternativa/aumentativa, materiais concretos, organização diferenciada, recursos digitais..."
                    )}

                    {renderTextArea(
                        "11. Necessidades Educacionais Identificadas",
                        "necessidades_educacionais",
                        "",
                        "Descreva de forma objetiva quais apoios o estudante necessita para: acessar o currículo, participar das atividades, comunicar-se, desenvolver autonomia, interagir, utilizar recursos de acessibilidade, superar as barreiras identificadas..."
                    )}

                    <SectionCard title={"12. Definição do Atendimento Educacional Especializado"}>
                        <Form.Item label="Objetivo geral do AEE">
                            {getFieldDecorator("definicao_atendimento_objetivo_geral", {
                                initialValue: dadosEstudoCaso.definicao_atendimento_objetivo_geral
                            })(
                                <TextArea
                                    rows={5}
                                    placeholder={"Descreva o objetivo geral do atendimento educacional especializado..."}
                                    style={{ minHeight: 130 }}
                                />
                            )}
                        </Form.Item>

                        <Form.Item label="Objetivos específicos">
                            {getFieldDecorator("definicao_atendimento_objetivos_especificos", {
                                initialValue: dadosEstudoCaso.definicao_atendimento_objetivos_especificos
                            })(
                                <TextArea
                                    rows={5}
                                    placeholder={"Descreva os objetivos específicos do atendimento..."}
                                    style={{ minHeight: 130 }}
                                />
                            )}
                        </Form.Item>
                    </SectionCard>

                    {renderTextArea(
                        "13. Plano de Intervenção do AEE",
                        "plano_intervencao",
                        "",
                        "Descreva o plano de intervenção do AEE...",
                        8
                    )}

                    {renderTextArea(
                        "14. Articulação com a Sala Regular",
                        "articulacao_sala_regular",
                        "",
                        "Registre como o professor de AEE e o professor regente irão trabalhar de forma colaborativa: planejamento, estratégias pedagógicas, recursos de acessibilidade, adaptações necessárias, acompanhamento da aprendizagem, compartilhamento de informações..."
                    )}

                    {renderTextArea(
                        "15. Articulação com a Família e Equipe Multiprofissional",
                        "articulacao_familia_equipe",
                        "",
                        "Registre as ações previstas junto à família e, quando necessário, à equipe multiprofissional da escola/rede..."
                    )}

                    {renderTextArea(
                        "16. Acompanhamento e Reavaliação",
                        "acompanhamento_reavaliacao",
                        "",
                        "Data do acompanhamento, avanços observados, dificuldades persistentes, estratégias que apresentaram resultados, novas necessidades identificadas, alterações necessárias no PAEE...",
                        6
                    )}

                    {renderTextArea(
                        "17. Considerações Finais",
                        "consideracoes_finais",
                        "",
                        "Registre uma síntese do estudo de caso, destacando as potencialidades do estudante, as barreiras identificadas, os apoios necessários e os encaminhamentos definidos para o AEE...",
                        8
                    )}

                    <div className="ant-drawer-footer">
                        <button
                            className="botao-secundario"
                            type="button"
                            onClick={handleClose}
                            style={{
                                marginRight: 20,
                                display: "inline-block"
                            }}
                        >
                            Cancelar
                        </button>

                        <button className="botao-principal" type="submit" disabled={isLoading}>
                            {isLoading ? <Icon type="loading" /> : null} Salvar estudo
                        </button>
                    </div>
                </Form>
            </div>
        </Drawer>
    );
};

export default Form.create({
    name: "form-drawer-estudo-caso-paee"
})(DrawerEstudoPAEE);
